import { module } from 'modujs'

export default class extends module {
  init() {
    this.fill = this.el.querySelector('.c-chart_fill')
    this.total = Number.parseFloat(this.fill.getAttribute('r')) * 2 * Math.PI

    this.defaultValue = this.el.getAttribute('data-value')
      ? Number.parseFloat(this.el.getAttribute('data-value'))
      : null
  }

  update(value) {
    const result = (value * this.total) / 100

    this.fill.style.strokeDasharray = `${result} ${this.total - result}`
  }

  reset() {
    this.fill.style.strokeDasharray = '0 314'
  }

  play() {
    if (this.defaultValue) {
      this.update(this.defaultValue)
    }
  }
}
